import React from 'react';

import { makeStyles } from '@mui/styles';
import { CardContent, Grid, Paper, Typography } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  container: {
    margin: 10,
  },
  patientChartCard: {
    ...theme.globalClasses.patientChartCard,
    '& p': {
      marginTop: 10,
    },
  },
  title: {
    fontSize: '24px !important',
    textAlign: 'left',
    margin: 'auto',
  },
}));

const GettingStarted = () => {
  const classes = useStyles();
  return (
    <Grid
      item
      xs={12}
    >
      <a id={'getting_started'} />
      <Paper className={classes.patientChartCard}>
        <CardContent>
          <Typography
            variant={'h1'}
            className={classes.title}
          >
            Getting Started
          </Typography>
          <p>
            Diet ID provides digital nutrition tools to assess and track current nutritional intake, develop custom
            nutrition plans based on health goals, and guide individuals to their goals through personalized digital
            daily coaching. As a partner, you can use our stand-alone web-based tools with your population.
          </p>
          <p>
            If you use another digital platform to manage your population and want to embed Diet ID’s modules there,
            Diet ID can support integration to help you build a seamless experience.
          </p>
          <p>
            Diet ID has 3 different modules: An assessment module, a goal setting module, and a daily actions module.
            Depending on your needs, the Diet ID team will configure your instance with the right combination of
            modules. Our team will also customize your instance of Diet ID with the correct branding, color palette,
            copy, custom questions, and custom content display. Your custom instance of Diet ID will be accessible via{' '}
            <a
              href="https://your-subdomain.dietid.com"
              rel="nofollow"
            >
              https://your-subdomain.dietid.com
            </a>
            . A unique subdomain can be provided by the Diet ID team.
          </p>
          <p>
            There are a few ways to integrate Diet ID into your experience. They generally address two concerns:{' '}
            <em>how the user interacts</em> with Diet ID’s modules and <em>how you retrieve the results</em> of those
            interactions.
          </p>

          <img
            src={process.env.PUBLIC_URL + '/api_flow.png'}
            style={{ margin: 'auto', width: '80%', display: 'block' }}
          />
        </CardContent>
      </Paper>
    </Grid>
  );
};
export default GettingStarted;
